import React from "react";
import styles from "./Activity.module.sass";

const Row = ({ item }) => {
	return (
		<div className={styles.row}>
			<div className={styles.col}>{item.type.replaceAll("_", " ")}</div>
			<div className={styles.col}>
				{item?.fromUser?.userName || item?.fromBrand?.userName}
			</div>
			<div className={styles.col}>{item?.toUser?.userName}</div>
			<div className={styles.col}>
				{item.payload?.price} {item.payload?.currency}
			</div>
			<div className={styles.col}>
				{new Date(item.createdAt).toLocaleString()}
			</div>
		</div>
	);
};

export default Row;
